var map = {
	"./avatar_m.svg": 1268,
	"./avatar_m_logo.svg": 55426,
	"./avatar_w.svg": 56430,
	"./avatar_w_logo.svg": 27304,
	"./business/Christian-Lautner.jpg": 96249,
	"./business/Dr-Inge-Lues.jpg": 74026,
	"./business/Dr-Markus-Mueschenich.jpg": 24531,
	"./core/bernd-neutschel.jpg": 2958,
	"./core/carolin-cienkowski.jpg": 85079,
	"./core/chris-rehse.jpg": 69730,
	"./core/david-berron.jpg": 52258,
	"./core/dominik-boeke.jpeg": 73338,
	"./core/emrah-duezel.jpg": 28530,
	"./core/eva-ackermann.jpg": 85556,
	"./core/florian-boesenkopf.jpg": 20041,
	"./core/florian-heinzmann.jpg": 60941,
	"./core/hannes-voßfeldt.jpg": 22390,
	"./core/hashim-naveed.jpg": 24349,
	"./core/ina-hempen.jpg": 94973,
	"./core/jana-schumann.jpg": 58145,
	"./core/julian-haupenthal.jpg": 13717,
	"./core/maike-kuehn.jpg": 83002,
	"./core/martin-leuckert.jpg": 8184,
	"./core/mileen-mollenhauer.jpg": 74736,
	"./core/nadine-diersch.jpg": 14205,
	"./core/pascal-robert.jpg": 74952,
	"./core/paula-saering.jpg": 44194,
	"./core/roman-ustinov.jpg": 24915,
	"./core/safa-bougouffa.jpg": 64983,
	"./core/susanne-wiesner.jpg": 30436,
	"./core/valentin-kauth.jpg": 13654,
	"./core/xandra-volkmann.jpg": 384,
	"./hero.svg": 483,
	"./science/frank-jessen.jpg": 36325,
	"./science/lars-nyberg.jpg": 22882,
	"./science/pierluigi-nicotera.jpg": 33340,
	"./science/robert-howard.jpg": 18342,
	"./science/william-jagust.jpg": 24866,
	"./science/wolfgang-hoffmann.jpg": 45273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28713;